import React from 'react';

interface ITruncatedTextProps {
    text: string;
    className?: string;
}

export function TruncatedText({ text, className }: ITruncatedTextProps) {
    if (!text) {
        return null;
    }

    return (
        <span className={['d-block', 'text-truncate', className].filter(Boolean).join(' ')} title={text}>
            {text}
        </span>
    );
}
